import { records as jobsRecords } from '@saucelabs/sl-module-jobs';

import types from './types';
import { createTestCaseReducers } from '../../../common/test-case/reducers';

const { initialState, reducer } = createTestCaseReducers({
  types,
  JobRecord: jobsRecords.RdcJobRecord,
});

export default reducer;
export { initialState };
